import { render } from "./HalamanBerita.vue?vue&type=template&id=020ae0b7&scoped=true"
import script from "./HalamanBerita.vue?vue&type=script&lang=js"
export * from "./HalamanBerita.vue?vue&type=script&lang=js"

import "./HalamanBerita.vue?vue&type=style&index=0&id=020ae0b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020ae0b7"]])

export default __exports__